import styled from 'styled-components'
import { Layout, Form, Alert } from 'antd'

export const LoginLayout = styled(Layout)`
  min-height: 100vh;
`

export const SiteLayout = styled(Layout)`
  background-color: white;
  padding: 0 24px 24px;
`

export const ContentLayout = styled(Layout.Content)`
  padding: 80px 0 0 0;
  margin: 0;
  min-height: 280px;
  user-select: none;
`

export const LoginForm = styled(Form)`
  width: 360px;
`

export const HeaderContainer = styled.div`
  margin-bottom: 20px;
`

export const LogoContainer = styled.div`
  margin-bottom: 60px;
`

export const Title = styled.div`
  font-weight: 600;
  font-size: 30px;
`

export const AccessMessage = styled.div`
  /* Стили для сообщения о необходимости входа */
`

export const ErrorAlert = styled(Alert)`
  margin-top: 16px;
  text-align: left;
`

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 24px;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
`

export const Footer = styled(Layout.Footer)`
  text-align: center;
  background: none;
`
